import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Chip,
  Divider,
  Stack,
  Alert,
} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

interface SubsidiaryNode {
  id?: string;
  label?: string;
  type?: string;
  jurisdiction?: string;
}

interface CompanySubsidiariesSectionProps {
  subsidiaries: SubsidiaryNode[];
}

const CompanySubsidiariesSection: React.FC<CompanySubsidiariesSectionProps> = ({ subsidiaries }) => (
  <Card sx={{ borderRadius: 2 }}>
    <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AccountBalanceIcon color="primary" />
        Subsidiaries / Investments
        <Chip label={subsidiaries.length} size="small" color="success" />
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {subsidiaries.length === 0 ? (
        <Alert severity="info">No subsidiaries found.</Alert>
      ) : (
        <List disablePadding>
          {subsidiaries.map((n, idx) => (
            <React.Fragment key={n.id ?? idx}>
              {idx > 0 && <Divider />}
              <ListItemButton
                component={RouterLink}
                to={`/companies/${encodeURIComponent(n.id ?? '')}`}
                sx={{ px: 0, py: { xs: 1.25, sm: 1 }, minWidth: 0 }}
              >
                <ListItemText
                  disableTypography
                  sx={{ minWidth: 0 }}
                  primary={
                    <Typography variant="body2" fontWeight="medium" sx={{ overflowWrap: 'anywhere' }}>
                      {n.label}
                    </Typography>
                  }
                  secondary={
                    n.type === 'company' ? (
                      <Stack direction="row" spacing={0.5} sx={{ mt: 0.5 }} flexWrap="wrap" useFlexGap>
                        <Chip label="Company" size="small" variant="outlined" />
                        {n.jurisdiction && (
                          <Chip label={n.jurisdiction} size="small" variant="outlined" />
                        )}
                      </Stack>
                    ) : (
                      <Chip label="Person" size="small" variant="outlined" sx={{ mt: 0.5 }} />
                    )
                  }
                />
              </ListItemButton>
            </React.Fragment>
          ))}
        </List>
      )}
    </CardContent>
  </Card>
);

export default CompanySubsidiariesSection;
